export default class CollectionEntity {
    constructor (data) {
        return data;
    }

}